import { render, staticRenderFns } from "./WorkCenter.vue?vue&type=template&id=1c0d9890&"
import script from "./WorkCenter.vue?vue&type=script&lang=js&"
export * from "./WorkCenter.vue?vue&type=script&lang=js&"
import style0 from "./WorkCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports